export default "__VITE_ASSET__5b7d105b__"